import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'answer-msg',
  templateUrl: './answer-msg.component.html',
  styleUrls: ['./answer-msg.component.scss']
})
export class AnswerMsgComponent implements OnInit {
  @Input() answer: string;
  @Input() questionTitle: string;

  constructor() { }

  ngOnInit() {
  }

}
